import { Component, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { IAppState } from '@literax/store';
import { WorkspaceSelectors } from '@literax/modules/documents/store/workspace/workspace.selectors';
import { environment } from '@environments/environment';
import { ELinkOutcome } from '@literax/models/link-outcome.model';


/**
 * Not found component displayed when the user enters an invalid url request
 */
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-signed',
  templateUrl: './signed.component.html',
  styleUrls: ['./signed.component.scss'],
})
export class SignedComponent implements OnDestroy {
  link = environment.domain + '/auth/registration';
  error$ = this.store.pipe(
    untilDestroyed(this),
    select(WorkspaceSelectors.errorDocument)
  );

  /**
   * The resolved outcome of the guest-link request that brought the recipient here, if any.
   *
   * `COMPLETED` means they had already participated and re-entered; absent means they have just
   * finished, which is how the existing success path reaches this screen (FR-030, FR-031, D-13).
   */
  linkOutcome$ = this.store.pipe(
    untilDestroyed(this),
    select(WorkspaceSelectors.linkOutcome)
  );

  errorMessage: any;
  errorCode: any;

  /**
   * Whether to show the already-participated wording instead of the success wording.
   *
   * Only `COMPLETED` qualifies. An absent or unrecognized outcome keeps the existing success
   * wording rather than rendering nothing, because a screen with no message is the defect this
   * feature exists to remove (FR-002, FR-031).
   */
  isAlreadyParticipated = false;

  constructor(private store: Store<IAppState>) {}

  ngOnInit(): void {
    this.linkOutcome$.pipe(untilDestroyed(this)).subscribe((outcome) => {
      this.isAlreadyParticipated = outcome === ELinkOutcome.COMPLETED;
    });

    this.error$.pipe(untilDestroyed(this)).subscribe((data) => {
      if (data !== null) {
        this.errorMessage = data.message;
        this.errorCode = data.code;
      } else {
        this.errorMessage = '';
        this.errorCode = null;
      }
    });
  }

  ngOnDestroy(): void {}
}
